import { EAccumulatorUnit } from 'components/TariffCard/constants';

export const TITLE_DICTIONARY = {
  [EAccumulatorUnit.KBYTE]: 'Интернет',
  [EAccumulatorUnit.SECONDS]: 'Звонки',
  [EAccumulatorUnit.MINUTES]: 'Звонки',
  [EAccumulatorUnit.SMS]: 'Сообщения',
  [EAccumulatorUnit.TV]: 'Телевидение',
  [EAccumulatorUnit.INTERNET_SPEED]: 'Скорость интернета',
};
